const SLIDE_A = 'linear-gradient(160deg, #e07a5f 0%, #8e3b46 100%)';
const SLIDE_B = 'linear-gradient(200deg, #3d5a80 0%, #98c1d9 100%)';
const TITLE_POS = { top: 'top-2', center: 'top-1/2 -translate-y-1/2', bottom: 'bottom-2' };

const ReelTransitionPreview = ({ transition = 'white', titlePosition = 'bottom' }) => {
  const isCut = transition === 'none';
  const isDip = transition === 'white' || transition === 'black';
  const layerAnim = isCut ? 'reel-cut' : transition === 'slide' ? 'reel-slide' : isDip ? 'reel-dip-slide' : 'reel-xfade';
  const pos = TITLE_POS[titlePosition] || TITLE_POS.bottom;

  return (
    <div className="flex flex-col items-center gap-1" data-testid="reel-transition-preview" data-transition={transition} data-title-position={titlePosition}>
      <div className="relative w-[54px] h-[96px] rounded-md overflow-hidden border bg-black shadow-sm" aria-hidden>
        <div className="absolute inset-0" style={{ background: SLIDE_A, animation: 'reel-kb 3s ease-in-out infinite alternate' }}>
          <div className={`absolute left-1.5 right-1.5 ${pos} space-y-0.5`} data-testid="reel-preview-title">
            <div className="h-1.5 w-4/5 rounded-sm bg-white/95" />
            <div className="h-1 w-1/2 rounded-sm bg-white/70" />
          </div>
        </div>
        <div className="absolute inset-0" style={{ background: SLIDE_B, animation: `${layerAnim} 3s ${isCut ? 'linear' : 'ease-in-out'} infinite` }} />
        {isDip && <div className="absolute inset-0" style={{ background: transition, animation: 'reel-dip-veil 3s ease-in-out infinite' }} />}
      </div>
      <span className="text-[10px] text-muted-foreground leading-none">Anteprima</span>
    </div>
  );
};

export default ReelTransitionPreview;
